import React from "react";

import * as Styles from "./styles";
import { useOnload } from "@utils/useOnLoad";

interface IGarageCardProps {
  tags: string[];
  garageName: string;
  rating: string;
  distance: string;
  address: string;
  actions?: any;
}

export default function GarageCard(props: IGarageCardProps) {
  const { tags, garageName, rating, distance, address, actions } = props;

  const renderRatingAndDistance = () => {
    const ratingText = rating ? `${rating} rated` : "4.5 rated";
    const distanceText = distance ? `${distance} km away` : "";
    return `${ratingText} ${ratingText && distance ? " | " : ""} ${distanceText}`;
  };

  const { on_load } = actions || {};

  useOnload({ on_load });

  return (
    <Styles.Wrapper>
      {!!tags?.length && (
        <Styles.TagsWrapper>
          {tags?.map((tag) => <Styles.Tag key={tag}>{tag}</Styles.Tag>)}
        </Styles.TagsWrapper>
      )}
      <Styles.GarageName>{garageName}</Styles.GarageName>
      {Boolean(rating || distance) && (
        <Styles.RatingsWrapper>
          <Styles.StarIcon src="https://storefront-consumer-assets.s3.ap-south-1.amazonaws.com/static/document-service/6708d9c1d80eac28705f8d5b.png" />
          <Styles.Rating>{renderRatingAndDistance()}</Styles.Rating>
        </Styles.RatingsWrapper>
      )}
      <Styles.Address>{address}</Styles.Address>
      <Styles.DottedLine />
    </Styles.Wrapper>
  );
}
